import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { DataService } from '@app/shared/services/data/data.service';

import { Observable } from 'rxjs';

/**
 * Checks if gsm is enabled in consul config.
 */
@Injectable({
  providedIn: 'root'
})
export class GsmEnabledGuard implements CanActivate {
  private dataService = inject(DataService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.dataService.getGsmActiveStatus();
  }
}
